import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PlaybooksSearchInput({
  actions
}) {
  return /*#__PURE__*/_jsx(SearchInput
  // @ts-expect-error component has wrong types
  , {
    onChange: actions.onSearchInputChange,
    marginBlockEnd: "100"
  });
}